module.exports = __webpack_public_path__ + "img/logo-main.4c69d234.svg";